export default __webpack_public_path__ + "static/media/script.6256c9a0.png";